import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
  list: {
    padding: theme.spacing(0, 2),
  },
  listItem: {},
})
const useStyles = makeStyles(styles)

export default function PanelFieldLinkValue(props) {
  const { value } = props

  const classes = useStyles()

  return (
    <ul className={classes.list}>
      {value.map((v) => (
        <li className={classes.listItem}>{v}</li>
      ))}
    </ul>
  )
}

PanelFieldLinkValue.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
}
